<template>
  <!-- 订舱管理 -->
  <div class="page-container-manage page-container-booking booking-management" id="ebOrderContainer">
    <el-form ref="manifestAddFormRef" class="form-panel" label-position="top">
      <el-row class="content-panel manage-content-panel">
        <!-- 查询-start -->
        <el-row class="query-module">
        <!-- 查询-start -->
        <el-row :gutter="10">
          <el-col :span="11">
            <el-form-item>
              <el-input
                size="small"
                placeholder="请输入单个或多个客户业务编号、订单号、提单号、箱号进行查询，多个单号用分号隔开"
                clearable
                v-model="nameComputed"
                :title="nameComputed"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top: 2px">
            <el-row>
              <el-button
                class="el-button-search"
                type="primary"
                size="small"
                plain
                @click="queryForm"
              >查询
              </el-button
              >
              <el-button type="primary"
                         size="small"
                         plain
                         @click="resetForm"
              >重置
              </el-button
              >
              <el-button
               class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                v-if="!moreInfoVisible ? 'hidden' : ''"
              >显示高级查询
               <svg-icon icon-class="arrow-down" class="svg-change-color"></svg-icon>
              </el-button>
              <el-button
               class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                v-if="moreInfoVisible ? 'hidden' : ''"
              >隐藏高级查询
              <svg-icon icon-class="arrow-up" class="svg-change-color"></svg-icon>
              </el-button>
            </el-row>
          </el-col>
          <el-col :span="7" style="margin-top: 2px">
            <el-row>
              <el-col>
                <el-form-item label="" style="color: #8c8c8c">
                  <label>开航日期 : </label><label>{{this.getTime(searchData.startEtd)}}到 {{this.getTime(searchData.endEtd)}}</label>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 查询-end -->
        <!-- 高级查询-start -->
        <el-row
          class="content-panel title-fix advanced-query"
          v-show="moreInfoVisible"
        >

          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="船公司:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_carrier"
                  :query-method="associate_queryMethod_carrier"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="custAlias"
                  value-prop="custAlias"
                  placeholder=""
                  v-model="searchData.carrierName"
                  :title="searchData.carrierName"
                  @change="giveCsCustId"
                  size="mini"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="实装大船船名/航次:">
                    <el-associate
                      ref="realVesselassociate"
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      label-prop="vesselName"
                      value-prop="vesselId"
                      placeholder=""
                      v-model="searchData.realVesselName"
                      :title="searchData.realVesselName"
                      size="mini"
                      name="realVesselName"
                      @change="onChangeRealVessel"

                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.realVoyage"
                      :title="searchData.realVoyage"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="创建日期从/到:">
                    <el-date-picker
                      v-model="searchData.startTime"
                      :title="searchData.startTime"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      default-time="00:00:00"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <label slot="label" class="label_no"></label>
                    <el-date-picker
                      v-model="searchData.endTime"
                      :title="searchData.endTime"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      default-time="23:59:59"
                      :picker-options="pickerOptions"
                      @change="changeEndTime"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="大船开航日期从/到:">
                    <el-date-picker
                      v-model="searchData.startEtd"
                      :title="searchData.startEtd"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      default-time="00:00:00"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <label slot="label" class="label_no"></label>
                    <el-date-picker
                      v-model="searchData.endEtd"
                      :title="searchData.endEtd"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      default-time="23:59:59"
                      placeholder=""
                      :picker-options="pickerOptions"
                      @change="changeEndEtd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="装货港:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_po"
                  :query-method="associate_queryMethod_po"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="portNameEn"
                  value-prop="mdPortId"
                  placeholder=""
                  v-model="searchData.polId"
                  :title="searchData.polName"
                  @change="onPolChange"
                  size="mini"
                  name="polName"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="卸货港:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_po"
                  :query-method="associate_queryMethod_po"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="portNameEn"
                  value-prop="mdPortId"
                  placeholder=""
                  v-model="searchData.podId"
                  :title="searchData.podName"
                  @change="onPodChange"
                  size="mini"
                  name="podName"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="交货地:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_po"
                  :query-method="associate_queryMethod_po"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="portNameEn"
                  value-prop="mdPortId"
                  placeholder=""
                  v-model="searchData.placeOfDeliveryId"
                  :title="searchData.placeOfDeliveryName"
                  @change="onPlaceOfDeliveryChange"
                  size="mini"
                  name="podName"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="大船船名/航次:">
                    <el-associate
                      ref="vesselAssociate"
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselName"
                      value-prop="vesselId"
                      placeholder=""
                      v-model="searchData.vesselName"
                      :title="searchData.vesselName"
                      size="mini"
                      name="vesselName"
                      @change="onChangeVessel"
                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.voyage"
                      :title="searchData.voyage"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>

          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="华贸分公司:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_csOffice"
                  :query-method="associate_queryMethod_csOffice"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="corpNameCn"
                  value-prop="sysCorpId"
                  placeholder=""
                  v-model="searchData.settleOfficeName"
                  :title="searchData.settleOfficeName"
                  size="mini"
                  @change="onChangeCsOffice"
                  case="upper"
                />
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item label="创建人:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_sysUser"
                  :query-method="associate_queryMethod_sysUser"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="userName"
                  value-prop="sysUserId"
                  placeholder=""
                  v-model="searchData.creatorName"
                  :title="searchData.creatorName"
                  size="mini"
                  @change="onChangeUser"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="订舱联系人:">
                <el-input
                  size="mini"
                  placeholder=""
                  clearable
                  v-model="searchData.custContact"
                  :title="searchData.custContact"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单ID:">
                <el-input
                  size="mini"
                  placeholder=""
                  clearable
                  v-model="searchData.ebOrderId"
                  :title="searchData.ebOrderId"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-top: 17px">
              <el-row
                type="flex"
                justify="end"
                align="middle"
                :gutter="10"
                class="el-row-margin"
              >
                <el-button
                  class="el-button-search"
                  type="primary"
                  size="small"
                  plain
                  @click="queryMoreForm"
                >查询
                </el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="resetMoreForm"
                >重置
                </el-button
                >
              </el-row>
            </el-col>
          </el-row>
        </el-row>
       </el-row>
        <!-- 高级查询-end -->
        <!-- 状态栏-start -->
        <el-row>
          <el-col class="tabsContainer tab-module">
            <el-tabs
              type="border-card"
              v-model="activeName"
              @tab-click="handleClick"
            >
              <el-tab-pane
                :label="'全部(' + count0 + ')'"
                name="all"
              ></el-tab-pane>
              <el-tab-pane
                v-for="(item, index) in ebOrderStatusList"
                :key="index"
                :name="item.value"
              >
                <span slot="label">{{ item.name + '(' }}<span
                  :class="[item.count > 0? 'hasTabPane': '']">{{ item.count }}</span><span>{{ ')' }}</span></span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <!-- 状态栏-end -->
        <el-row class="state-panel">
        <!-- 按钮栏-start -->
        <el-row style="background-color:#fff;padding:10px">
          <el-button type="primary" size="small" plain class="el-button-search" @click="addEbOrder"
          >新增
          </el-button
          >
          <!--          <el-button type="primary" size="small" plain @click="EditEbOrder"
                    >编辑
                    </el-button
                    >-->
          <el-button type="primary" size="small" plain @click="batchSubmit" :loading="loading"
          >批量提交
          </el-button
          >
          <el-button type="primary" size="small" plain @click="excel"
          >批量导出
          </el-button
          >
          <el-button type="primary" size="small" plain @click="btnCopy"
          >复制
          </el-button
          >
          <!-- <el-button type="primary" size="small" plain @click="templateBooking">模板订舱</el-button> -->
          <!-- <el-button type="primary" size="small" plain @click="ediBooking"
            >EDI订舱</el-button
          > -->
          <el-button type="primary" size="small" plain @click="uploadGuarantee"
          >上传保函
          </el-button
          >

          <!--          <el-button type="primary" size="small" plain @click="cancelApply"
                               >退关</el-button>-->

          <el-button type="primary" size="small" plain @click="statusHistory"
          >状态历史
          </el-button
          >
          <el-button type="primary" size="small" plain @click="revokeUpdating" :loading="loading"
          >撤销提交
          </el-button
          >
          <el-button type="primary" size="small" plain @click="invoiceQuery"
          >账单详情
          </el-button
          >
          <el-button type="primary" size="small" plain @click="makeManifest"
          >制作舱单
          </el-button
          >
          <el-button type="primary" size="small" plain @click="makeBLN"
          >制作提单
          </el-button
          >
          <el-button type="primary" size="small" plain @click="maintainVGM"
          >维护VGM
          </el-button
          >
          <!-- <el-button type="primary" size="small" plain @click="revokeUpdating">撤销提交</el-button> -->
          <add-up-box
            :add-visible-flag-init="addVisible"
            :ebOrder="addOrCopyData"
          />
          <template-booking-up-box
            :template-booking-visible-flag-init="templateBookingVisible"
          />
          <upload-guarantee-up-box
            :upload-guarantee-visible.sync="uploadGuaranteeVisible"
            :resultEbOrder = "resultEbOrder"
            ref="uploadGuaranteeUpBoxRef"
          />
          <download-attachch-up-box
            :download-attachment-visible-flag-init="downloadAttachmentVisible"
            :ebOrder="addOrCopyData"
          />
        </el-row>
        <!-- 按钮栏-end -->
        <!-- 表格-start -->
        <el-row style="padding: 0 1px">
          <hot-table
            :after-on-cell-mouse-down="totalSingleClick"
            ref="ebOrderTableRef"
            :data-source="ebOrderTableDataSource"
            renderAllRows="true"
            outsideClickDeselects="outsideClickDeselects"
            :settings="ebOrderTableSettings"
            @cellDblclick="dbClickCustBizNo"
            cssClass="ebOrderStatus(row)"
            col-settings-key="ebOrder">
            <hot-column
              :has-tip="true"
              data="custBizNo"
              title="客户业务编号"
              width="150"
              >
              <!-- <span style="background-color: none"></span> --><column-link-renderer url="/booking/edit" param-name="ebOrderId" type="edit"
                                    hot-renderer class="custBizNo"></column-link-renderer>
            </hot-column>
            <hot-column
              :has-tip="true"
              data="mblNo"
              title="提单号"
              width="150"
            ></hot-column>
            <hot-column
              :css="colClass"
              :has-tip="true"
              data="ebOrderStatus"
              title="订单状态"
              width="150"
              dictName="EB_ORDER_BK_STATUS"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="orderStatus"
              title="订单提交状态"
              width="150"
              dictName="EB_ORDER_STATUS"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="vgmStatus"
              title="VGM状态"
              width="150"
              dictName="EB_VGM_STATUS"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="orderNo"
              title="订单号"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="carrierName"
              title="船公司"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="vesselNameEn"
              title="大船船名"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="voyage"
              title="大船航次"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="realVesselNameEn"
              title="实装大船船名"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="realVoyage"
              title="实装大船航次"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="etd"
              date-format="YYYY-MM-DD"
              title="开航时间"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="polName"
              title="装货港"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="podName"
              title="卸货港"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="porName"
              title="收货地"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="issueMode"
              title="签单方式"
              dictName="BLISSUEMODE"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="ctnNum"
              title="预配箱量"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="bargeTransitPortCode"
              title="进港代码"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="isCancelApply"
              title="退关申请标志"
              width="150"
              dictName="EB_CANCEL_APPLY_STATUS"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="createTime"
              date-format="YYYY-MM-DD HH:mm:ss"
              title="创建时间"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="bargeVesselName"
              title="驳船船名"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="bargeVoyage"
              title="驳船航次"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="bargeEtd"
              title="驳船开航日期"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="csName"
              title="华贸客服"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="settleOfficeName"
              title="华贸分公司"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="creatorName"
              title="创建人"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="ebOrderId"
              title="订单ID"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="placeOfDeliveryName"
              title="交货地"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="custContact"
              title="订舱联系人"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="customsVesselName"
              title="报关船名"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="customsVoyage"
              title="报关航次"
              width="150"
            ></hot-column>
          </hot-table>
          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination
              :current-page="pageConfig.currentPage"
              :layout="pageConfig.layout"
              :page-size="pageConfig.pageSize"
              :page-sizes="pageConfig.pageSizes"
              :total="pageConfig.total"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
          <!-- 分页end -->
        </el-row>
        <!-- 表格-end -->
      </el-row>
     </el-row>
    </el-form>
  </div>
</template>

<script>
import ebOrder from "@/api/ebOrder";
import {
  queryCarrierInfo,
  queryDictRows,
  queryPoInfo,
  querySysUser,
  querySales,
  querySysUserInfo,
  queryVoyageInfo,
} from "@/api/commonService";
import addUpBox from "@/views/booking/AddUpBox";
import templateBookingUpBox from "@/views/booking/TemplateBookingUpBox";
import uploadGuaranteeUpBox from "@/views/booking/UploadGuaranteeUpBox";
import downloadAttachchUpBox from "@/views/booking/DownloadAttachmentUpBox";
import {batchCancel, batchRevokeSub, batchSubmit, getOrderdata} from "@/api/bookingRequest";
import columnLinkRenderer from "../../components/CustomRenderer/columnLinkRenderer";
import columnDownloadRenderer from "../../components/CustomRenderer/columnDownloadRenderer";
import sysCorpCust from "@/api/sysCorpCust";
import {downloadExcel} from "@/utils/downloadExcel";
import { export_json_to_excel } from "@/vendor/Export2Excel";
import Xlsx from 'xlsx'

export default {
  name: "bookingManage",
  components: {
    addUpBox,
    templateBookingUpBox,
    uploadGuaranteeUpBox,
    downloadAttachchUpBox,
    columnLinkRenderer,
    columnDownloadRenderer
  },
  data() {
    return {
      ebOrderStatusAllList: [],
      resizeObserver: null,
      loading: false,
      //查询条件
      no: "",
      //查询
      searchData: {
        custContact: "",
        realVoyage: "",
        realVesselName: "",
        csCustId: "",
        carrierName: "",
        vesselName: "",
        voyage: "",
        createTime: [],
        startTime: "",
        endTime: "",
        polName: "",
        polId: "",
        podName: "",
        podId: "",
        placeOfDeliveryId: "",
        placeOfDeliveryName: "",
        vesselId: "",
        settleOffice: "",
        settleOfficeName: "",
        creatorName: "",
        creatorId: "",
        ebOrderId: "",
        startEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() - 24 * 1000 * 3600 * 60
            ).toLocaleDateString()
          ).getTime()
        ),
        endEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() + 24 * 1000 * 3600 * 61
            ).toLocaleDateString()
          ).getTime() +
          24 * 1000 * 3600 -
          1
        ),
      },
      //标志点击哪个查询按钮
      queryButton: 0,
      //显示高级查询
      moreInfoVisible: false,
      //tab状态栏
      activeName: "all",
      //各订单状态数量
      count0: 0,
      //新增弹出框状态
      addVisible: false,
      //模板订舱弹出框状态
      templateBookingVisible: false,
      //保函上传弹出框状态
      uploadGuaranteeVisible: false,
      resultEbOrder: {},
      //Attachment下载弹出框状态
      downloadAttachmentVisible: false,
      //传递给复制/新增
      addOrCopyData: {},
      //订单状态列表
      ebOrderStatusList: [],
      // 表格数据
      ebOrderTableDataSource: [],
      //当前行数据
      currentEbOrder: {},
      // 表格设置
      ebOrderTableSettings: {
        defaultCollapsed: true,
        checkStrict: false, //单选
        treeView: true,
        height: 320,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      pageID: {},
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100, 500],
      },
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      associate_columns_sysUser: [
        {
          title: "创建人",
          field: "userName",
        },
      ],
      //华贸分公司联想控件
      associate_columns_csOffice: [
        {
          title: "代码",
          field: "sysCorpId",
        },
        // {
        //   title: "公司简称",
        //   field: "corpName",
        // },
        {
          title: "中文全称",
          field: "corpNameCn",
        },
      ],
      // 装/卸货港联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      //日期设置
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
  },
  activated() {
    setTimeout(() => {
        this.$nextTick (() => {
          this.$refs.ebOrderTableRef.render()
          })
    },100);
  },

  computed: {
    nameComputed: {
      get: function () {
        return this.no;
      },
      set: function (val) {
        this.no = val.toUpperCase();
      },
    },
  },
  mounted() {
    let self = this;
    console.log(self)
    self.queryEbOrderStatus();
    self.queryEbOrderBkStatus();
    self.queryEbVGMStatus();
    self.queryBLISSUEMODE();
    self.queryEbOrderType();
    self.queryEbCancalApplyStatus();
    if (self.$route.params.fromWhere === "afterSubmit") {
      self.queryMoreForm();
    }
    this.ebOrderTableSettings.height = document.body.clientHeight - 100 - 150;
  },
  methods: {
    refontBold(){
       var boldDatas = document.getElementsByClassName('data-bold')
           if(boldDatas.length>0){
             for(var x=0; boldDatas.length>0; x++){
              boldDatas[0].classList.remove('data-bold')
             }
           }
        var newStatus = document.getElementsByClassName('new-status')
           if(newStatus.length>0){
             for(var j=0; newStatus.length>0; j++){
              newStatus[0].classList.remove('new-status')
             }
           }
            this.fontBold()
    },
    totalSingleClick(i) {
     var classarr = i.realTarget.classList
     if(classarr){
      for(var a=0; a<classarr.length; a++){
        if(classarr[a]==="expand-toggle"||classarr[a]==="ht-column-title-text"){
         this.refontBold()
        }
      }
     }
    },
    fontBold(){
      var expandToggle = document.getElementsByClassName('expand-toggle')
        for (var j=0; j<expandToggle.length; j++){
        var c = expandToggle[j].parentNode.parentNode.parentNode
        c.classList.add('data-bold')
      }
       var bgBlues = document.getElementsByClassName('bgBlue')
         for(var b=0; b<bgBlues.length; b++){
        bgBlues[b].parentNode.classList.add('new-status')
         }
    },
    colClass(row){
      if(row.value === "UNLOAD"){
       row.td.classList.add('bgBlue')
      }
    },
    getTime(date){
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      let D = date.getDate() + ' ';
      this.Time = Y+M+D;
      return this.Time
    },
    giveCsCustId(value, selectedRows) {
      let self = this;
      self.searchData.csCustId = selectedRows.csCustId;
    },
    changMoreInfoVisible() {
      let self = this
      this.moreInfoVisible = !this.moreInfoVisible
      if (this.moreInfoVisible) {
        self.ebOrderTableSettings.height = self.ebOrderTableSettings.height - 143
      } else {
        self.ebOrderTableSettings.height = self.ebOrderTableSettings.height + 143
      }
    },
    changeEndEtd() {
      let self = this;
      self.searchData.endEtd = new Date(
        self.searchData.endEtd.getTime() + 1000 * 24 * 3600 - 100
      );
    },
    changeEndTime() {
      let self = this;
      self.searchData.endTime = new Date(
        self.searchData.endTime.getTime() + 1000 * 24 * 3600 - 100
      );
    },
    //华贸客服联想控件改变事件
    onChangeCsOffice(value, selectedRows) {
      this.searchData.settleOffice = selectedRows.sysCorpId;
      this.searchData.settleOfficeName = selectedRows.corpNameCn;
    },
    onChangeUser(value, selectedRows) {
      this.searchData.creatorId = selectedRows.sysUserId;
      this.searchData.creatorName = selectedRows.userName;
    },
    onPolChange(value, selectedRows) {
      this.searchData.polId = selectedRows.mdPortId;
      this.searchData.polName = selectedRows.portNameEn;
    },
    onPodChange(value, selectedRows) {
      this.searchData.podId = selectedRows.mdPortId;
      this.searchData.podName = selectedRows.portNameEn;
    },
    onPlaceOfDeliveryChange(value, selectedRows) {
      this.searchData.placeOfDeliveryId = selectedRows.mdPortId;
      this.searchData.placeOfDeliveryName = selectedRows.portNameEn;
    },
    onChangeRealVessel() {
      let record = this.$refs.realVesselassociate.list[this.$refs.realVesselassociate.hoverIndex];
      this.searchData.realVesselName = record.vesselName;
      this.searchData.realVoyage = record.voyage;
      this.searchData.realVesselId = record.vesselId;
    },
    onChangeVessel() {
      let record = this.$refs.vesselAssociate.list[this.$refs.vesselAssociate.hoverIndex];
      this.searchData.vesselName = record.vesselName;
      this.searchData.voyage = record.voyage;
      this.searchData.vesselId = record.vesselId;
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where:
          "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({keyword, pageSize, currentPage}) {
      let params = {};
      let whereObj = null;
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      if (this.searchData.vesselName) {
        params.vesselId = this.searchData.vesselId;
        whereObj =
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)";
      } else {
        whereObj =
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)";
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 客商用户联想控件数据源
    associate_queryMethod_sysUser({ keyword, pageSize, currentPage }) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        userName: keyword,
        custId: userInfo.custId,
      };
      return new Promise((resolve) => {
        querySysUser(params).then(res => {
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch((err) => {
        console.log(err);
      });
    },
    // 华贸分公司联想控件数据源
    associate_queryMethod_csOffice({keyword, pageSize, currentPage}) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let params = {
        page: self.pageConfig.currentPage,
        limit: self.pageConfig.pageSize,
        csCustId: userInfo.custId,
      };
      if (keyword !== "") {
        params.corpNameCn = keyword;
      }
      return new Promise((resolve) => {
        sysCorpCust.getsysCorpCustCsOffice(params).then((res) => {
          resolve({
            records: res.data.data,
            total: res.data.length,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 装/卸货港联想控件数据源
    associate_queryMethod_po({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage(this.pageConfig.currentPage);
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // 单击行事件
    rowClick(val) {
      let self = this;
      self.currentEbOrder = val.record;
    },
    // 表格双击事件
    dbClickCustBizNo(val) {
      let self = this;
      let row = val.record;
      // sessionStorage.setItem("ebOrderParams", JSON.stringify([row]));
      // sessionStorage.setItem("ebOrderType", "edit");
      self.$router.push({
        path: "/booking/edit",
        query: {
          ebOrderId: row.ebOrderId,
          type: "edit",
        },
      });
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      if (tab.name === "all") {
        self.ebOrderTableDataSource = self.ebOrderStatusAllList;
        self.pageConfig.total = self.count0;
        return;
      }
      self.pageConfig.currentPage = 1;
      let target = self.ebOrderStatusList.find(
        (item) => item.value === tab.paneName
      );
      self.ebOrderTableDataSource = target.filterList;
      self.pageConfig.total = target.count
     setTimeout(function(){
      self.refontBold()
    },1000)
    },
    queryStatusPage() {
      let self = this;
      if (self.queryButton === 1) {
        self.queryForm();
      } else if (self.queryButton === 2) {
        self.queryMoreForm();
      }
    },
    // 重置
    resetForm() {
      this.no = "";
    },
    resetMoreForm() {
      this.searchData = {
        custContact: "",
        carrierName: "",
        vesselName: "",
        voyage: "",
        realVesselName: "",
        realVoyage: "",
        createTime: [],
        startTime: "",
        endTime: "",
        polName: "",
        podName: "",
        startEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() - 24 * 1000 * 3600 * 60
            ).toLocaleDateString()
          ).getTime()
        ),
        endEtd: new Date(
          new Date(
            new Date(
              new Date().getTime() + 24 * 1000 * 3600 * 61
            ).toLocaleDateString()
          ).getTime() +
          24 * 1000 * 3600 - 1
        ),
      };
    },
    //简单查询
    queryForm() {
      let self = this;
      self.queryButton = 1;
      //排除所有的空格
      self.no = self.no.replaceAll(" ", "");
      if (self.no.trim().length === 0) {
        self.queryMoreForm();
        // self.$coreMethods.message(
        //     "warning",
        //     "请输入单个或多个客户业务编号;提单号；订单号; 箱号"
        // );
      } else {
        let searchData = {
          currentPage: self.pageConfig.currentPage,
          pageSize: self.pageConfig.pageSize,
          arrayNo: self.no.split(";"),
        };
        // self.queryAll();
        ebOrder.queryEbOrder(searchData).then((res) => {
          console.log("queryEbOrder", res);
          if (res.success) {
            self.ebOrderTableDataSource = res.records.records;
            self.pageConfig.total = res.records.totalRecord;
            self.count0 = self.pageConfig.total = res.records.totalRecord;
            self.filterStatus(res.records.records);
            if (res.records.totalRecord === 0) {
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            } else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    //高级查询
    queryMoreForm() {
      let self = this;
      self.searchData.orderStatus = self.activeName === "all" ? "" : self.activeName;
      let searchColumns = [
        {
          propertyName: "custContact",
          value: self.searchData.custContact,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "creatorId",
          value: self.searchData.creatorId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "ebOrderId",
          value: self.searchData.ebOrderId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "settleOffice",
          value: self.searchData.settleOffice,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "carrierId",
          value: self.searchData.csCustId,
          operation: "EQ",
          connector: "and",
        },
        /*{
          propertyName: "carrierName",
          value: self.searchData.carrierName,
          operation: "LIKE",
          connector: "and",
        },*/
        /*{
          propertyName: "realVesselNameEn",
          value: self.searchData.realVesselName,
          operation: "LIKE",
          connector: "and",
        },*/
        {
          propertyName: "realVesselId",
          value: self.searchData.realVesselId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "realVoyage",
          value: self.searchData.realVoyage,
          operation: "LIKE",
          connector: "and",
        },

        /* {
           propertyName: "vesselNameEn",
           value: self.searchData.vesselName,
           operation: "LIKE",
           connector: "and",
         },*/
        {
          propertyName: "vesselId",
          value: self.searchData.vesselId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "voyage",
          value: self.searchData.voyage,
          operation: "LIKE",
          connector: "and",
        },
        {
          propertyName: "startTime",
          aliasName: "createTime",
          value: self.searchData.startTime,
          operation: "GE",
          connector: "and",
        },
        {
          propertyName: "endTime",
          aliasName: "createTime",
          value: self.searchData.endTime,
          operation: "LE",
          connector: "and",
        },
        {
          propertyName: "startEtd",
          aliasName: "etd",
          value: self.searchData.startEtd,
          operation: "GE",
          connector: "and",
        },
        {
          propertyName: "endEtd",
          aliasName: "etd",
          value: self.searchData.endEtd,
          operation: "LE",
          connector: "and",
        },
        /*{
          propertyName: "polName",
          value: self.searchData.polName,
          operation: "LIKE",
          connector: "and",
        },*/
        {
          propertyName: "polId",
          value: self.searchData.polId,
          operation: "EQ",
          connector: "and",
        },
        /*{
          propertyName: "podName",
          value: self.searchData.podName,
          operation: "LIKE",
          connector: "and",
        },*/
        {
          propertyName: "podId",
          value: self.searchData.podId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "placeOfDeliveryId",
          value: self.searchData.placeOfDeliveryId,
          operation: "EQ",
          connector: "and",
        },
        {
          propertyName: "orderStatus",
          value: "",
          operation: "LIKE",
          connector: "and",
        },
        {
          propertyName: "transferStatus",
          value: 1,
          operation: "NEQ",
          connector: "and",
        },
      ];
      let query = {searchColumns: searchColumns};

      self.queryButton = 2;
      let num = 0;
      for (let s in self.searchData) {
        if (self.searchData[s] !== "") {
          num++;
        }
      }
      if (num === 0) {
        self.$coreMethods.message("warning", "至少输入一个查询条件");
      } else {
        self.searchData.page = self.pageConfig.currentPage;
        self.searchData.limit = self.pageConfig.pageSize;
        self.searchData.orderStatus =
          self.activeName === "all" ? "" : self.activeName;

        let params = self.$daoServiceUtils.buildQueryParams(ebOrder, query, {
          page: self.pageConfig.currentPage,
          limit: self.pageConfig.pageSize,
        });
        ebOrder.queryMoreEbOrder(params).then((res) => {
          if (res.success) {
            self.ebOrderTableDataSource = res.data.data;
            self.count0 = self.pageConfig.total = res.data.totalRecord;
            self.filterStatus(res.data.data);
            if (res.data.totalRecord === 0) {
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            } else {
              self.$coreMethods.message("success", "查询成功！");
                setTimeout(function(){
                self.refontBold()
              },1000)
            }
          }
        });
      }
    },
    // 账单查询
    invoiceQuery() {
      console.log('账单查询')
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else if (params.length > 1) {
        self.$coreMethods.message("warning", "请确认是否单选");
      } else {
        if (params[0].mblNo === null) {
          self.$coreMethods.message("warning", "提单号不能为空");
          return;
        }
        self.$router.push({
          name: 'orderInvoiceDetails',
          params: {
            ebOrderId: params[0].ebOrderId,
            mblNo: params[0].mblNo,
            goOrderId: params[0].goOrderId,
            type: "manage",
          },
        })
      }
    },
    //简单查询所有
    queryAll() {
      let self = this;
      let allSearchData = {
        arrayNo: self.no.trim().split(";"),
        orderStatus: "",
      };
      ebOrder.queryEbOrder(allSearchData).then((res) => {
        console.log("queryEbOrder", res);
        if (res.success) {
          self.filterStatus(res.records.records);
        }
      });
    },
    //高级查询所有
    queryAllMore() {
      let self = this;
      let allSearchData = {
        csCustId: self.searchData.csCustId,
        carrierName: self.searchData.carrierName,
        vesselName: self.searchData.vesselName,
        voyage: self.searchData.voyage,
        startTime: self.searchData.startTime[0],
        endTime: self.searchData.startTime[1],
        polName: self.searchData.polName,
        podName: self.searchData.podName,
        orderStatus: "",
      };
      ebOrder.queryMoreEbOrder(allSearchData).then((res) => {
        console.log("queryMoreEbOrder", res);
        if (res.success) {
          self.filterStatus(res.data);
        }
          setTimeout(function(){
            self.refontBold()
          },1000)
      });
    },
    //各订单状态数量
    filterStatus(data) {
      let self = this;
      self.ebOrderStatusAllList = JSON.parse(JSON.stringify(data));
      self.initStatus();
      self.ebOrderStatusList.forEach((dictItem) => {
        let filterList = data.filter(
          (item) => dictItem.value === item.orderStatus
        );
        dictItem.filterList = filterList;
        dictItem.count = filterList.length;
      });

      if (self.activeName !== 'all') {
        let targetStatus = self.ebOrderStatusList.find(item => item.value === self.activeName)
        self.ebOrderTableDataSource = targetStatus.filterList
      }
    },
    initStatus() {
      let self = this;
      self.ebOrderStatusList.forEach((dictItem) => {
        dictItem.count = 0;
      });
    },
    //获取订单状态数据字典
    queryEbOrderStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_ORDER_STATUS").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_ORDER_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        });
        self.ebOrderStatusList = dict;
        console.log("ebOrderStatusList", dict);
        // 数据字典
        self.$hotTableUtils.registDict({EB_ORDER_STATUS: dict});
      });
    },
    //获取订单提交状态数据字典
    queryEbOrderBkStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_ORDER_BK_STATUS").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_ORDER_BK_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        self.ebOrderBkStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({EB_ORDER_BK_STATUS: dict});
      });
    },
    //获取vgm状态数据字典
    queryEbVGMStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_VGM_STATUS").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_VGM_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        // 数据字典
        self.$hotTableUtils.registDict({EB_VGM_STATUS: dict});
      });
    },
    //获取签单状态数据字典
    queryBLISSUEMODE() {
      let self = this;
      queryDictRows("MD_CODE_DICT$BLISSUEMODE").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$BLISSUEMODE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        // 数据字典
        self.$hotTableUtils.registDict({BLISSUEMODE: dict});
      });
    },
    //获取数据来源数据字典
    queryEbOrderSource() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_ORDER_SOURCE").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_ORDER_SOURCE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        // 数据字典
        self.$hotTableUtils.registDict({EB_ORDER_SOURCE: dict});
      });
    },
    //获取委托类型数据字典
    queryEbOrderType() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_ORDER_TYPE").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_ORDER_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        // 数据字典
        self.$hotTableUtils.registDict({EB_ORDER_TYPE: dict});
      });
    },
    //获取退关申请标志数据字典
    queryEbCancalApplyStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_CANCEL_APPLY_STATUS").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_CANCEL_APPLY_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        // 数据字典
        self.$hotTableUtils.registDict({EB_CANCEL_APPLY_STATUS: dict});
      });
    },
    //点击
    clickModule(e) {
      console.log("clickModule", e);
      let self = this;
      if (e === 1) {
        //编辑
        this.$router.push({
          path: "/booking/edit",
          params: {
            ebOrder: self.currentEbOrder,
          },
        });
      } else if (e === 2) {
        //复制
        let ebOrder = self.currentEbOrder;
        self.addOrCopyData = {
          copyFlag: 1,
          bizTypeCode: "MFEF",
          bizTypeName: "海运整箱出口",
          inputMethond: "M",
          orderType: "SUB",
          isCancelApply: 0,
          custId: ebOrder.custId,
          custName: ebOrder.custName,
          isLcl: 0,
          orderStatus: ebOrder.orderStatus,
          custBizNo: ebOrder.custBizNo,
          agreementNo: ebOrder.agreementNo,
          nameAccount: ebOrder.nameAccount,
          csId: ebOrder.csId,
          csName: ebOrder.csName,
          carrierSales: ebOrder.carrierSales,
          hblPaymentType: ebOrder.hblPaymentType,
          hblPaymentPlace: ebOrder.hblPaymentPlace,
          hblPaymentPlaceId: ebOrder.hblPaymentPlaceId,
          hblPaymentContact: ebOrder.hblPaymentContact,
          hblTransportTermFrom: ebOrder.hblTransportTermFrom,
          hblTransportTermTo: ebOrder.hblTransportTermTo,
          issueMode: ebOrder.issueMode,
          placeOfIssueName: ebOrder.placeOfIssueName,
          placeOfIssueId: ebOrder.placeOfIssueId,
          noOfOriginal: ebOrder.noOfOriginal,
          noOfCopy: ebOrder.noOfCopy,
          custContact: ebOrder.custContact,
          custContactTel: ebOrder.custContactTel,
          custContactEmail: ebOrder.custContactEmail,
          porId: ebOrder.porId,
          porName: ebOrder.porName,
          porCode: ebOrder.porCode,
          polId: ebOrder.polId,
          polName: ebOrder.polName,
          polCode: ebOrder.polCode,
          potId: ebOrder.potId,
          potName: ebOrder.potName,
          potCode: ebOrder.potCode,
          podId: ebOrder.podId,
          podName: ebOrder.podName,
          podCode: ebOrder.podCode,
          placeOfDeliveryId: ebOrder.placeOfDeliveryId,
          placeOfDeliveryName: ebOrder.placeOfDeliveryName,
          placeOfDeliveryCode: ebOrder.placeOfDeliveryCode,
          bargeTransitPortCode: ebOrder.bargeTransitPortCode,
          carrierId: "根据对话框中选择的船公司赋值",
          carrierName: "根据对话框中选择的船公司赋值",
          isDeleted: 0,
          vgmStatus: "UNSENT",
          vgmApprovalStatus: "NEW",
        };
        self.addVisible = !self.addVisible;
      } else {
        //下载附件
        self.addOrCopyData = self.currentEbOrder;
        self.downloadAttachmentVisible = !self.downloadAttachmentVisible;
      }
    },
    //新增
    addEbOrder() {
      let self = this;
      self.addOrCopyData = {
        bizTypeCode: "MFEF",
        bizTypeName: "海运整箱出口",
        bizBigTypeCode: "MFE",
        bizBigTypeName: "海运集装整箱出口",
        inputMethond: "M",
        orderType: "SUB",
        isCancelApply: 0,
        // custId: "登录人的委托单位",
        // custName: "登录人的委托单位",
        isLcl: 0,
        orderStatus: "NEW",
        carrierId: "根据对话框中选择的船公司赋值",
        carrierName: "根据对话框中选择的船公司赋值",
        isDeleted: 0,
        vgmStatus: "UNSENT",
        vgmApprovalStatus: "NEW",
      };
      // self.addVisible = !self.addVisible;
      self.$router.push({
        path: "/booking/Add",
        //name: "bookingAdd",
        params: {
          type: "add",
        },
      });
    },
    EditEbOrder() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else if (params.length > 1) {
        self.$coreMethods.message("warning", "请确认是否单选");
      } else {
        console.log(params);
        sessionStorage.setItem("ebOrderParams", JSON.stringify(params));
        sessionStorage.setItem("ebOrderType", "edit");
        self.$router.push({
          name: "bookingEdit",
          query: {
            ebOrderId: params[0].ebOrderId,
            type: "edit",
          },
        });
      }
    },
    // 复制
    btnCopy() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else if (params.length > 1) {
        self.$coreMethods.message("warning", "请确认是否单选");
      } else {
        console.log(params);
        sessionStorage.setItem("ebOrderParams", JSON.stringify(params));
        sessionStorage.setItem("ebOrderType", "copy");
        self.$router.push({
          path: "/booking/Add",
          //name: "bookingAdd",
          query: {
            ebOrderId: params[0].ebOrderId,
            type: "copy",
          },
        });
      }
    },
    //批量提交
    batchSubmit() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      let ebOrderIdsArr = [];
      let ebOrderStatus = [];
      let canSubmit = true;
      self.loading = true;
      if (params.length === 0) {
        self.loading = false;
        self.$coreMethods.message("warning", "请勾选记录");
      } else {
        params.forEach((item) => {
          if(item.orderStatus !== "NEW" && item.orderStatus !== "REJ"){
            canSubmit = false;
          }
          ebOrderStatus.push(item.orderStatus);
          ebOrderIdsArr.push(item.ebOrderId);
        });
        if (canSubmit) {
          batchSubmit({ebOrderIds: ebOrderIdsArr, dataType: "ORDER"}).then(
            (res) => {
              if (res.success) {
                self.$coreMethods.message("success", "批量提交成功");
                self.queryStatusPage();
              } else {
                self.$coreMethods.message("error", "批量提交失败");
              }
              self.loading = false;
            }
          );
        } else {
          self.loading = false;
          self.$coreMethods.message("warning", "此状态不能提交");
        }
      }
    },
    excel(){
          var  selectData = []
            if(this.$refs.ebOrderTableRef.getSelections().length>0){
              selectData = this.$refs.ebOrderTableRef.getSelections()
            }else{
              if(this.ebOrderTableDataSource.length>0){
                selectData = this.ebOrderTableDataSource
              }
            }

          selectData.forEach((item) => {
              item.etd = this.$moment(item.etd).format("yyyy-MM-DD");
              item.createTime = this.$moment(item.invoiceDate).format("yyyy-MM-DD hh:mm:ss");
           });

            var tableCol =this.$refs.ebOrderTableRef.$children
            var str =''
            var head = ''
            for(var i=0; i<tableCol.length-2; i++){
              str+= tableCol[i].columnSettings.data
              head+= tableCol[i].columnSettings.title
              if(i!==tableCol.length-3){
                str+=','
                head+=','
              }
            }
           var strs = str.split(',');
           var heads = head.split(',');
           var data = selectData.map((a) => strs.map((b) => a[b]));
           var date = this.$moment(this.currentTime()).format("yyyy-MM-DD hh:mm:ss");
           var fileName = "eborder" + date;
           export_json_to_excel({
            header: heads,// 表头
            data: data, // 数据列表
            filename: fileName,// 保存文件名
          });
        },
        currentTime() {
            var date = new Date();
            var year = date.getFullYear(); //月份从0~11，所以加一
            let month = date.getMonth();
            console.log("month",month);
            var dateArr = [
                date.getMonth() + 1,
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds(),
            ];
            //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
            for (var i = 0; i < dateArr.length; i++) {
                if (dateArr[i] >= 1 && dateArr[i] <= 9) {
                    dateArr[i] = "0" + dateArr[i];
                }
            }
            var strDate =
                year +
                "/" +
                dateArr[0] +
                "/" +
                dateArr[1] +
                " " +
                dateArr[2] +
                ":" +
                dateArr[3] +
                ":" +
                dateArr[4];
                //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
               	//this.date = strDate;
            return strDate;
        },
     currentTime() {
             var date = new Date();
             var year = date.getFullYear(); //月份从0~11，所以加一
             let month = date.getMonth();
             console.log("month",month);
             var dateArr = [
                 date.getMonth() + 1,
                 date.getDate(),
                 date.getHours(),
                 date.getMinutes(),
                 date.getSeconds(),
             ];
             //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
             for (var i = 0; i < dateArr.length; i++) {
                 if (dateArr[i] >= 1 && dateArr[i] <= 9) {
                     dateArr[i] = "0" + dateArr[i];
                 }
             }
             var strDate =
                 year +
                 "/" +
                 dateArr[0] +
                 "/" +
                 dateArr[1] +
                 " " +
                 dateArr[2] +
                 ":" +
                 dateArr[3] +
                 ":" +
                 dateArr[4];
                 //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
                	//this.date = strDate;
             return strDate;
         },
    //模板订舱
    templateBooking() {
      this.templateBookingVisible = !this.templateBookingVisible;
    },
    //edi订舱
    ediBooking() {
      this.$router.push("/booking/Edi");
    },
    //上传保函
    uploadGuarantee() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        getOrderdata({ebOrderId: params[0].ebOrderId}).then(res => {
          console.info(res.records);
          let resultEbOrder = res.records;
          self.resultEbOrder = res.records;
          let serviceItems = [];
          resultEbOrder.ebServiceItems.forEach(item => {
            serviceItems.push(item.serviceCode);
          });
          if (params[0].orderStatus !== resultEbOrder.orderStatus) params[0].orderStatus = resultEbOrder.orderStatus;
          if (params[0].ebOrderStatus !== resultEbOrder.ebOrderStatus) params[0].ebOrderStatus = resultEbOrder.ebOrderStatus;
          if (resultEbOrder.orderStatus !== "CRM") return self.$coreMethods.message("warning", "请选择订单提交状态为已接受的记录！");
          if (resultEbOrder.ebOrderStatus === "UNLOAD") return self.$coreMethods.message("warning", "请选择订单状态不为以退关的记录！");
          self.uploadGuaranteeVisible = true;
          self.$refs.uploadGuaranteeUpBoxRef.setEbOrderId(params[0]);
        });
      }
    },
    //退关
    cancelApply() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else {
        let flag = true;
        params.forEach((item) => {
          if (item.orderStatus === "CNL") {
            flag = false;
          }
        });
        if (!flag) {
          self.$coreMethods.message("warning", "勾选的记录中包含已退关的记录");
        } else {
          self.$coreMethods.confirm(
            function () {
              batchCancel(params).then((res) => {
                if (res.success) {
                  self.$coreMethods.message("success", "退关申请成功");
                  self.queryStatusPage();
                } else {
                  self.$coreMethods.message("error", "退关申请失败");
                }
              });
            },
            function () {
              self.$emit("close");
            },
            false,
            "",
            "确定要退关吗?",
            "error"
          );
        }
      }
    },
    //状态历史
    statusHistory() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      }else if (params[0].orderStatus != "CRM") {
        self.$coreMethods.message("warning", "请选择已接收的数据");
      } else {
        this.$router.push({
          name: "StatusHistory",
          params: {
            orderNo: params[0].orderNo,
          },
        });
      }
    },
    //制作舱单
    makeManifest() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        getOrderdata({ebOrderId: params[0].ebOrderId}).then(res => {
          console.info(res.records);
          let resultEbOrder = res.records;
          let serviceItems = [];
          resultEbOrder.ebServiceItems.forEach(item => {
            serviceItems.push(item.serviceCode);
          });
          if (params[0].orderStatus !== resultEbOrder.orderStatus) params[0].orderStatus = resultEbOrder.orderStatus;
          if (params[0].ebOrderStatus !== resultEbOrder.ebOrderStatus) params[0].ebOrderStatus = resultEbOrder.ebOrderStatus;
          if (serviceItems.indexOf("FT") === -1) return self.$coreMethods.message("warning", "没有舱单服务项，不允许制作舱单！");
          if (resultEbOrder.orderStatus !== "CRM") return self.$coreMethods.message("warning", "请选择订单提交状态为已接收的记录！");
          if (resultEbOrder.ebOrderStatus === "UNLOAD") return self.$coreMethods.message("warning", "请选择订单状态不为已退关的记录！");
          self.$router.push({
            name: "manifestAdd",
            query: {
              ebOrderId: params[0].ebOrderId,
              isAddManiFest: false,
              mainfest: "makeManifest",
            },
          });
        });
      }
    },
    //制作提单
    makeBLN() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        getOrderdata({ebOrderId: params[0].ebOrderId}).then(res => {
          console.info(res.records);
          let resultEbOrder = res.records;
          let serviceItems = [];
          resultEbOrder.ebServiceItems.forEach(item => {
            serviceItems.push(item.serviceCode);
          });
          if (params[0].orderStatus !== resultEbOrder.orderStatus) params[0].orderStatus = resultEbOrder.orderStatus;
          if (params[0].ebOrderStatus !== resultEbOrder.ebOrderStatus) params[0].ebOrderStatus = resultEbOrder.ebOrderStatus;
          if (serviceItems.indexOf("MBL") === -1) return self.$coreMethods.message("warning", "没有MBL服务项，不允许制作提单！");
          if (resultEbOrder.orderStatus !== "CRM") return self.$coreMethods.message("warning", "请选择订单提交状态为已接收的记录！");
          if (resultEbOrder.ebOrderStatus === "UNLOAD") return self.$coreMethods.message("warning", "请选择订单状态不为已退关的记录！");
          self.$router.push({
            name: "ladingbillEdit",
            params: {
              ebOrderId: params[0].ebOrderId,
              type: "edit",
            },
          });
        });
      }
    },
    //维护vgm
    maintainVGM() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        getOrderdata({ebOrderId: params[0].ebOrderId}).then(res => {
          console.info(res.records);
          let resultEbOrder = res.records;
          let serviceItems = [];
          resultEbOrder.ebServiceItems.forEach(item => {
            serviceItems.push(item.serviceCode);
          });
          if (params[0].orderStatus !== resultEbOrder.orderStatus) params[0].orderStatus = resultEbOrder.orderStatus;
          if (params[0].ebOrderStatus !== resultEbOrder.ebOrderStatus) params[0].ebOrderStatus = resultEbOrder.ebOrderStatus;
          if (resultEbOrder.orderStatus !== "CRM") return self.$coreMethods.message("warning", "请选择订单提交状态为已接收的记录！");
          if (resultEbOrder.ebOrderStatus === "UNLOAD") return self.$coreMethods.message("warning", "请选择订单状态不为已退关的记录！");
          self.$router.push({
            name: "VGMEdit",
            params: {
              ebOrderId: params[0].ebOrderId,
              type: "edit",
            },
          });
        });
      }
    },
    //撤销提交
    revokeUpdating() {
      let self = this;
      let params = self.$refs.ebOrderTableRef.getSelections();
      let ebOrderIdsArr = [];
      let orderStatusArr = [];
      let orderStatus = "";
      self.loading = true;
      if (params.length === 0) {
        self.loading = false;
        self.$coreMethods.message("warning", "请勾选记录");
      } else {
        let target = params.find(item => item.orderStatus !== 'SUB' && item.orderStatus !== 'UPDSUB')
        if (target) {
          self.loading = false;
          return self.$coreMethods.message("warning", "请选择新增提交或修改提交的订单进行操作");
        }
        params.forEach((item) => {
          orderStatusArr.push(item.orderStatus);
          ebOrderIdsArr.push(item.ebOrderId);
        });
        if (new Set(orderStatusArr).size === 1) {
          if (orderStatusArr[0] === "SUB") {
            orderStatus = "NEW";
          } else if (orderStatusArr[0] === "UPDSUB") {
            orderStatus = "CRM";
          }
          self.$coreMethods.confirm(
            function () {
              batchRevokeSub({
                ebOrderIds: ebOrderIdsArr,
                orderStatus: orderStatus,
                dataType: "ORDER"
              }).then((res) => {
                if (res.success) {
                  params.forEach((item) => {
                    item.orderStatus = orderStatus;
                  });
                  self.$coreMethods.message("success", "撤销提交成功");
                  self.queryStatusPage();
                  self.submitVisible = true;
                } else {
                  self.$coreMethods.message("error", "撤销提交失败");
                }
                self.loading = false;
              });
            },
            function () {
            },
            false,
            "是否执行撤销操作？"
          );
        } else {
          self.$coreMethods.message(
            "warning",
            "请确认订单状态为是否全为新增提交或者全为修改提交"
          );
        }
      }
    },
  },
};
</script>
<style lang="scss">
// ::v-deep .el-tabs__content {
//   display: none !important;
// }


.state-panel{
  .el-col-12{
  padding-top: 10px;
  }
}
.el-pagination{
  padding: 10px 20px !important;
}
.booking-management{
.el-link--inner{
  text-decoration:underline !important;
}
}

.is-underline::after{
   content:none !important;
}
.data-bold{
  font-weight: 600;
}
.new-status{
  background-color:#DCE0E3 !important;
}
</style>
